import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {gtmService} from '../services/gtm/gtmService';

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        gtmService.triggerPageView({
            page_path: location.pathname + location.search + location.hash,
            page_search: location.search,
            page_hash: location.hash,
        });
    }, [location]);
};
